// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"f0-z"};